import { Spin } from 'antd';

function NotFoundContent({ loading = false }) {
  if (loading) return <Spin />;

  return 'Sonuç bulunamadı. Farklı bir arama yapabilir veya Yazar Ekle butonuna tıklayarak yeni bir yazar ekleyebilirsiniz.';
}

export default NotFoundContent;
